<ng-container *ngIf="transaction.isCard; else noCardTemplate">
  <div><b i18n>Payment status: </b> {{ transaction.stateDescription }}</div>
  <div><b i18n>Total amount: </b> {{ transaction.amount | currency: transaction.currency.code }}
  </div>
  <div><b i18n>Reference: </b> {{ transaction.reference }}</div>
  <div><b i18n>Paid by: </b> {{ transaction.method?.displayName }}</div>

  <mat-divider></mat-divider>
  <br/>
  <div *ngIf="!transaction.isCanceled">
    <button mat-flat-button color="primary" (click)="onDownload()" i18n>Download receipt</button>
  </div>
</ng-container>

<ng-template #noCardTemplate>
    <p *ngIf="transaction.isSettled; else notCompletedTemplate" i18n>
        This payment has been received.
    </p>

    <div style="display: flex; flex-flow: row nowrap;">
        <div style="flex-grow: 1;">
          <h3 i18n>Total amount</h3>
          <p>{{ transaction.amount | currency: transaction.currency.code }}
        </div>

        <div style="flex-grow: 1;">
          <h3 i18n>Reference</h3>
          <p>{{ transaction.reference }}</p>
        </div>

        <div style="flex-grow: 1;">
          <h3 i18n>Method</h3>
          <p>{{ transaction.method?.displayName }}</p>
        </div>

        <div style="flex-grow: 1;">
          <h3 i18n>Status</h3>
          <p>{{ transaction.stateDescription }}</p>
        </div>
    </div>

    <ub-button-list *ngIf="!transaction.isBeingRefunded && !transaction.isRefunded && !transaction.isSettled">
        <button mat-flat-button
                color="primary"
                type="button"
                (click)="onNotPaid()" i18n>Change payment method</button>
    </ub-button-list>
</ng-template>

<ng-template #notCompletedTemplate>
    <p i18n>We will notify you when payment reaches our accounts.</p>
</ng-template>

<div *ngIf="!transaction.isCanceled && transaction.refunds.length > 0">
    <h2 i18n>Refunds</h2>
    <div *ngFor="let refund of transaction.refunds; index as index">
        <div style="display: flex; flex-flow: row nowrap;">
            <div style="flex-grow: 1;">
            <h3>#</h3>
            <p>{{ index + 1}}.</p>
            </div>

            <div style="flex-grow: 1;">
            <h3 i18n>State</h3>
            <p>{{ refund.state }}</p>
            </div>

            <div style="flex-grow: 1;">
            <h3 i18n>Reference</h3>
            <p>{{ refund.reference }}</p>
            </div>

            <div style="flex-grow: 1;">
            <h3 i18n>Payment amount</h3>
            <p>{{ transaction.amount | currency: transaction.currency.code }}</p>
            </div>

            <div style="flex-grow: 1;">
            <h3 i18n>Refund amount</h3>
            <p>{{ refund.amount | currency: refund.currency.code }}</p>
            </div>

            <ng-container *ngIf="canPerformActionForRefund(refund)">
                <div style="flex-grow: 1;">
                <h3 i18n>Action</h3>
                <p><button type="button" (click)="onRefund(index)" i18n>Refund</button></p>
                </div>
            </ng-container>
        </div>
    </div>
</div>
